import Vue from 'vue'

import '@/plugins/axios'

const server = {

  // wpUrl: 'http://staging.petcoparkevents.com/swp/wp-json/wp/v2/',
  wpUrl: 'https://thefinestcollective.com/wp-json/wp/v2/',
  acfUrl: 'https://thefinestcollective.com/wp-json/acf/v3/',

  getVenues () {
    // console.log(Vue.axios);
    return Vue.axios.get(`${this.wpUrl}venue-detail?per_page=100`)
      .then(response => {
        return response;
      })
      .catch(e => {
        return e;
      });
  },
  getPackages () {
    // console.log(Vue.axios);
    return Vue.axios.get(`${this.wpUrl}package?filter[orderby]=menu_order&order=asc`)
      .then(response => {
        return response;
      })
      .catch(e => {
        return e;
      });
  },
  getEnhancements () {
    // console.log(Vue.axios);
    return Vue.axios.get(`${this.wpUrl}pages/910`)
      .then(response => {
        return response;
      })
      .catch(e => {
        return e;
      });
  },

  async getLevels () {
    return Vue.axios.get(`${this.wpUrl}venue-levels?per_page=100`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        return e;
      });
  },
  async getSiteOptions () {
    return Vue.axios.get(`${this.acfUrl}options/options`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        return e;
      });
  },
  getLevel (levelId) {
    Vue.axios.get(`${this.wpUrl}venue-detail?venue-levels=${levelId}`)
      .then(response => {
        return response.data;

        // if (this.debug) console.log("level ID: " + this.selectedLevel.id);
        // if (this.debug) console.log(this.selectedLevel)
      })
  },
  getInitialImages() {
    return Vue.axios.get(`${this.wpUrl}slideshow/56`)
      .then(response => {
        return response;
      })
      .catch(e => {
        return e;
      });
  }
};

export default server;
